module.exports = __webpack_public_path__ + "assets/images/no-image/payspace-image@2x.157fd18ac0730cfcbd9f6724587a229c.webp";